import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "lotto-wrapper",
  class: "contents-wrapper"
}
const _hoisted_2 = { id: "lotto-analysis" }
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "loading-text" }, "데이터를 불러오는 중...", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "analysis-head" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "analysis-title" }, "번호 분석"),
  /*#__PURE__*/_createElementVNode("p", { class: "analysis-sub" }, "역대 당첨 데이터로 번호의 출현 패턴을 살펴봅니다. 재미로 보는 참고 지표이며, 당첨을 보장하지 않아요.")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "charts-row"
}
const _hoisted_9 = { class: "section-card frequency-card" }
const _hoisted_10 = { class: "chart-header" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "section-card-title" }, "번호별 출현빈도", -1)
const _hoisted_12 = { class: "sort-buttons" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "각 번호가 1등 당첨에 나온 총 횟수입니다(막대 뒤 연한 부분은 보너스). 길수록 자주 나왔어요.", -1)
const _hoisted_14 = { class: "frequency-chart" }
const _hoisted_15 = {
  key: 0,
  class: "bar-rank"
}
const _hoisted_16 = { class: "number" }
const _hoisted_17 = { class: "bar-track" }
const _hoisted_18 = { class: "bar-count" }
const _hoisted_19 = {
  key: 0,
  class: "section-card heatmap-card"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "section-card-title" }, "동반출현 히트맵", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "두 번호가 같은 회차에 함께 나온 빈도. 칸이 진할수록 자주 함께 나온 조합이에요.", -1)
const _hoisted_22 = { class: "heatmap-wrapper" }
const _hoisted_23 = { class: "heatmap-grid" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "heatmap-label corner" }, null, -1)
const _hoisted_25 = { class: "heatmap-label" }
const _hoisted_26 = ["onMouseenter"]
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"heatmap-legend\"><span>적음</span><div class=\"legend-block heat-1\"></div><div class=\"legend-block heat-2\"></div><div class=\"legend-block heat-3\"></div><div class=\"legend-block heat-4\"></div><div class=\"legend-block heat-5\"></div><span>많음</span></div>", 1)
const _hoisted_28 = {
  key: 1,
  class: "section-card"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "section-card-title" }, [
  /*#__PURE__*/_createTextVNode("당첨번호 빈도 티어 분석 "),
  /*#__PURE__*/_createElementVNode("span", { class: "title-meta" }, "최근 50회")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "전체 번호를 출현빈도 상·중·하위로 나눴을 때, 매 회차 당첨번호가 각 그룹에서 몇 개씩 나왔는지 보여줍니다.", -1)
const _hoisted_31 = { class: "tier-summary" }
const _hoisted_32 = { class: "tier-summary-item" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "tier-label tier-high" }, "상위 빈도", -1)
const _hoisted_34 = { class: "tier-value" }
const _hoisted_35 = { class: "tier-numbers" }
const _hoisted_36 = { class: "tier-summary-item" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "tier-label tier-mid" }, "중위 빈도", -1)
const _hoisted_38 = { class: "tier-value" }
const _hoisted_39 = { class: "tier-numbers" }
const _hoisted_40 = { class: "tier-summary-item" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "tier-label tier-low" }, "하위 빈도", -1)
const _hoisted_42 = { class: "tier-value" }
const _hoisted_43 = { class: "tier-numbers" }
const _hoisted_44 = { class: "tier-table-wrapper" }
const _hoisted_45 = { class: "tier-table tier-detail-table" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "회차"),
    /*#__PURE__*/_createElementVNode("th", null, "당첨번호"),
    /*#__PURE__*/_createElementVNode("th", null, "상위"),
    /*#__PURE__*/_createElementVNode("th", null, "중위"),
    /*#__PURE__*/_createElementVNode("th", null, "하위"),
    /*#__PURE__*/_createElementVNode("th", null, "비율")
  ])
], -1)
const _hoisted_47 = { class: "tier-balls" }
const _hoisted_48 = { class: "tier-cell-detail" }
const _hoisted_49 = { class: "tier-cell-count" }
const _hoisted_50 = {
  key: 0,
  class: "tier-cell-nums"
}
const _hoisted_51 = { class: "tier-cell-detail" }
const _hoisted_52 = { class: "tier-cell-count" }
const _hoisted_53 = {
  key: 0,
  class: "tier-cell-nums"
}
const _hoisted_54 = { class: "tier-cell-detail" }
const _hoisted_55 = { class: "tier-cell-count" }
const _hoisted_56 = {
  key: 0,
  class: "tier-cell-nums"
}
const _hoisted_57 = { class: "tier-stack-bar" }
const _hoisted_58 = {
  key: 0,
  class: "stack-label"
}
const _hoisted_59 = {
  key: 0,
  class: "stack-label"
}
const _hoisted_60 = {
  key: 0,
  class: "stack-label"
}
const _hoisted_61 = {
  key: 2,
  class: "section-card"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "section-card-title" }, [
  /*#__PURE__*/_createTextVNode("홀짝 · 번호대 분석 "),
  /*#__PURE__*/_createElementVNode("span", { class: "title-meta" }, "최근 50회")
], -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "회차마다 홀수/짝수가 몇 개였는지, 번호가 낮은·중간·높은 구간에 어떻게 분포했는지 보여줍니다.", -1)
const _hoisted_64 = { class: "oe-hl-summary" }
const _hoisted_65 = { class: "oe-hl-item" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "oe-hl-label" }, "평균 홀수", -1)
const _hoisted_67 = { class: "oe-hl-value" }
const _hoisted_68 = { class: "oe-hl-item" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "oe-hl-label" }, "평균 짝수", -1)
const _hoisted_70 = { class: "oe-hl-value" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "oe-hl-divider" }, null, -1)
const _hoisted_72 = { class: "oe-hl-summary" }
const _hoisted_73 = { class: "oe-hl-item" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "oe-hl-label" }, "낮은숫자 (1~15)", -1)
const _hoisted_75 = { class: "oe-hl-value" }
const _hoisted_76 = { class: "oe-hl-item" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "oe-hl-label" }, "중간숫자 (16~30)", -1)
const _hoisted_78 = { class: "oe-hl-value" }
const _hoisted_79 = { class: "oe-hl-item" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "oe-hl-label" }, "높은숫자 (31~45)", -1)
const _hoisted_81 = { class: "oe-hl-value" }
const _hoisted_82 = { class: "tier-table-wrapper" }
const _hoisted_83 = { class: "tier-table" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "회차"),
    /*#__PURE__*/_createElementVNode("th", null, "당첨번호"),
    /*#__PURE__*/_createElementVNode("th", null, "홀"),
    /*#__PURE__*/_createElementVNode("th", null, "짝"),
    /*#__PURE__*/_createElementVNode("th", null, "낮"),
    /*#__PURE__*/_createElementVNode("th", null, "중"),
    /*#__PURE__*/_createElementVNode("th", null, "높"),
    /*#__PURE__*/_createElementVNode("th", null, "합계")
  ])
], -1)
const _hoisted_85 = { class: "tier-balls" }
const _hoisted_86 = {
  key: 3,
  class: "section-card"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "section-card-title" }, [
  /*#__PURE__*/_createTextVNode("끝수별 출현빈도 "),
  /*#__PURE__*/_createElementVNode("span", { class: "title-meta" }, "최근 50회")
], -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "번호의 일의 자리(끝수, 예: 7·17·27·37)별로 얼마나 나왔는지 모은 것입니다.", -1)
const _hoisted_89 = { class: "last-digit-chart" }
const _hoisted_90 = { class: "last-digit-label" }
const _hoisted_91 = { class: "bar-track" }
const _hoisted_92 = { class: "bar-count" }
const _hoisted_93 = {
  key: 4,
  class: "section-card"
}
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "section-card-title" }, [
  /*#__PURE__*/_createTextVNode("연번 · 합계 분석 "),
  /*#__PURE__*/_createElementVNode("span", { class: "title-meta" }, "최근 50회")
], -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "연속된 번호(예: 14·15)가 포함된 비율과, 6개 번호 합계가 어느 구간에 몰리는지 보여줍니다.", -1)
const _hoisted_96 = { class: "consecutive-summary" }
const _hoisted_97 = { class: "consecutive-item" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "consecutive-label" }, "연번 포함 비율", -1)
const _hoisted_99 = { class: "consecutive-value" }
const _hoisted_100 = { class: "consecutive-item" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "consecutive-label" }, "평균 합계", -1)
const _hoisted_102 = { class: "consecutive-value" }
const _hoisted_103 = { class: "consecutive-item" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "consecutive-label" }, "합계 범위", -1)
const _hoisted_105 = { class: "consecutive-value" }
const _hoisted_106 = { class: "sum-chart-container" }
const _hoisted_107 = {
  key: 5,
  class: "section-card"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "section-card-title" }, [
  /*#__PURE__*/_createTextVNode("1등 당첨금 추이 "),
  /*#__PURE__*/_createElementVNode("span", { class: "title-meta" }, "최근 100회")
], -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "회차별 1등 1인당 당첨금(억원)의 변화입니다. 판매량·당첨자 수에 따라 오르내려요.", -1)
const _hoisted_110 = { class: "chart-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bar = _resolveComponent("Bar")!
  const _component_Line = _resolveComponent("Line")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_7,
            (_ctx.numberCountList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          class: _normalizeClass({ active: _ctx.sortMode === 'number' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortMode = 'number'))
                        }, "번호순", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass({ active: _ctx.sortMode === 'desc' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortMode = 'desc'))
                        }, "많은순", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass({ active: _ctx.sortMode === 'asc' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortMode = 'asc'))
                        }, "적은순", 2)
                      ])
                    ]),
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedNumberCount, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'bar-' + item.number,
                          class: "frequency-bar-wrapper"
                        }, [
                          (_ctx.sortMode !== 'number')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(idx + 1), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass([_ctx.getColorClass(item.number), "lotto-ball bar-ball"])
                          }, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(item.number), 1)
                          ], 2),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", {
                              class: "bar-fill",
                              style: _normalizeStyle({ width: _ctx.getBarWidth(item.count) + '%' })
                            }, null, 4),
                            (item.bonusCount > 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "bar-fill-bonus",
                                  style: _normalizeStyle({ left: _ctx.getBarWidth(item.count) + '%', width: _ctx.getBarWidth(item.bonusCount) + '%' })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.count) + "+" + _toDisplayString(item.bonusCount), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.accompanyList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(45, (n) => {
                              return _createElementVNode("div", {
                                key: 'hl-' + n,
                                class: "heatmap-label"
                              }, _toDisplayString(n), 1)
                            }), 64)),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(45, (row) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: 'hr-' + row
                              }, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(row), 1),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(45, (col) => {
                                  return _createElementVNode("div", {
                                    key: 'hc-' + row + '-' + col,
                                    class: _normalizeClass(["heatmap-cell", row === col ? 'heat-diagonal' : _ctx.getHeatClass(row, col)]),
                                    onMouseenter: ($event: any) => (_ctx.showHeatmapTooltip($event, row, col)),
                                    onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideHeatmapTooltip && _ctx.hideHeatmapTooltip(...args)))
                                  }, null, 42, _hoisted_26)
                                }), 64))
                              ], 64))
                            }), 64))
                          ])
                        ]),
                        _hoisted_27,
                        (_ctx.tooltipVisible)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "heatmap-tooltip",
                              style: _normalizeStyle({ top: _ctx.tooltipY + 'px', left: _ctx.tooltipX + 'px' })
                            }, _toDisplayString(_ctx.tooltipText), 5))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.tierAnalysisRows.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.avgTierRatio.high) + "%", 1),
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tierGroupNumbers.high, (n) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: 'tsh-' + n,
                            class: _normalizeClass(["tier-num-badge", _ctx.getColorClass(n)])
                          }, _toDisplayString(n), 3))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.avgTierRatio.mid) + "%", 1),
                      _createElementVNode("div", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tierGroupNumbers.mid, (n) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: 'tsm-' + n,
                            class: _normalizeClass(["tier-num-badge", _ctx.getColorClass(n)])
                          }, _toDisplayString(n), 3))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.avgTierRatio.low) + "%", 1),
                      _createElementVNode("div", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tierGroupNumbers.low, (n) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: 'tsl-' + n,
                            class: _normalizeClass(["tier-num-badge", _ctx.getColorClass(n)])
                          }, _toDisplayString(n), 3))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("table", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTierRows, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: 'tier-' + row.drwNo
                          }, [
                            _createElementVNode("td", null, _toDisplayString(row.drwNo), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_47, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.numbers, (num, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: 'tb-' + row.drwNo + '-' + i,
                                    class: _normalizeClass(["tier-ball", _ctx.getColorClass(num)])
                                  }, _toDisplayString(num), 3))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("span", _hoisted_49, _toDisplayString(row.high), 1),
                                (row.highNums.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.highNums, (n) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: 'rh-' + row.drwNo + '-' + n,
                                          class: _normalizeClass(["tier-mini-ball", _ctx.getColorClass(n)])
                                        }, _toDisplayString(n), 3))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("span", _hoisted_52, _toDisplayString(row.mid), 1),
                                (row.midNums.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.midNums, (n) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: 'rm-' + row.drwNo + '-' + n,
                                          class: _normalizeClass(["tier-mini-ball", _ctx.getColorClass(n)])
                                        }, _toDisplayString(n), 3))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("span", _hoisted_55, _toDisplayString(row.low), 1),
                                (row.lowNums.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.lowNums, (n) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: 'rl-' + row.drwNo + '-' + n,
                                          class: _normalizeClass(["tier-mini-ball", _ctx.getColorClass(n)])
                                        }, _toDisplayString(n), 3))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", {
                                  class: "stack-high",
                                  style: _normalizeStyle({ width: (row.high / 6 * 100) + '%' })
                                }, [
                                  (row.high > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, "상위"))
                                    : _createCommentVNode("", true)
                                ], 4),
                                _createElementVNode("div", {
                                  class: "stack-mid",
                                  style: _normalizeStyle({ width: (row.mid / 6 * 100) + '%' })
                                }, [
                                  (row.mid > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, "중위"))
                                    : _createCommentVNode("", true)
                                ], 4),
                                _createElementVNode("div", {
                                  class: "stack-low",
                                  style: _normalizeStyle({ width: (row.low / 6 * 100) + '%' })
                                }, [
                                  (row.low > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, "하위"))
                                    : _createCommentVNode("", true)
                                ], 4)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  (_ctx.tierAnalysisRows.length > 10)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "expand-btn",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tierExpanded = !_ctx.tierExpanded))
                      }, _toDisplayString(_ctx.tierExpanded ? '접기' : '더보기 (' + _ctx.tierAnalysisRows.length + '회)'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.oddEvenRows.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _hoisted_62,
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.avgOddEven.odd) + "개", 1)
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _hoisted_69,
                      _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.avgOddEven.even) + "개", 1)
                    ])
                  ]),
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.avgNumRange.low) + "개", 1)
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.avgNumRange.mid) + "개", 1)
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.avgNumRange.high) + "개", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("table", _hoisted_83, [
                      _hoisted_84,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleOddEvenRows, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: 'oe-' + row.drwNo
                          }, [
                            _createElementVNode("td", null, _toDisplayString(row.drwNo), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_85, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.numbers, (num, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: 'oeb-' + row.drwNo + '-' + i,
                                    class: _normalizeClass(["tier-ball", _ctx.getColorClass(num)])
                                  }, _toDisplayString(num), 3))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(row.odd), 1),
                            _createElementVNode("td", null, _toDisplayString(row.even), 1),
                            _createElementVNode("td", null, _toDisplayString(row.lowRange), 1),
                            _createElementVNode("td", null, _toDisplayString(row.midRange), 1),
                            _createElementVNode("td", null, _toDisplayString(row.highRange), 1),
                            _createElementVNode("td", null, _toDisplayString(row.sum), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  (_ctx.oddEvenRows.length > 10)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "expand-btn",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.oeExpanded = !_ctx.oeExpanded))
                      }, _toDisplayString(_ctx.oeExpanded ? '접기' : '더보기 (' + _ctx.oddEvenRows.length + '회)'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.lastDigitData.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                  _hoisted_87,
                  _hoisted_88,
                  _createElementVNode("div", _hoisted_89, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastDigitData, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'ld-' + item.digit,
                        class: "last-digit-bar-wrapper"
                      }, [
                        _createElementVNode("div", _hoisted_90, _toDisplayString(item.digit), 1),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", {
                            class: "bar-fill",
                            style: _normalizeStyle({ width: (item.count / _ctx.maxLastDigit * 100) + '%' })
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_92, _toDisplayString(item.count) + "회", 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.consecutiveData.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                  _hoisted_94,
                  _hoisted_95,
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _hoisted_98,
                      _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.consecutiveRate) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _hoisted_101,
                      _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.avgSum), 1)
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _hoisted_104,
                      _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.sumRange.min) + " ~ " + _toDisplayString(_ctx.sumRange.max), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _createVNode(_component_Bar, {
                      data: _ctx.sumChartData,
                      options: _ctx.sumChartOptions
                    }, null, 8, ["data", "options"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.lottoResults.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                  _hoisted_108,
                  _hoisted_109,
                  _createElementVNode("div", _hoisted_110, [
                    _createVNode(_component_Line, {
                      data: _ctx.prizeChartData,
                      options: _ctx.prizeChartOptions
                    }, null, 8, ["data", "options"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}